module.exports = __webpack_public_path__ + "static/media/db9d12b0-9307-4b1f-88bf-ebb676516c3b.17fa6bca.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/1274157/db9d12b0-9307-4b1f-88bf-ebb676516c3b.woff
// module id = 1669
// module chunks = 2